import notifyToSlackChannel from 'react-slack-notification';
import Error500 from './500';

export default function ErrorFallback({error, resetErrorBoundary}) 
{
  if (process.env.NEXT_PUBLIC_ENVIRONMENT == "production")
  {
    notifyToSlackChannel('https://hooks.slack.com/services/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',
                        `message      :-  ${error.toString()} \n stacktrace    :-  ${error.stack} \n  platform     :-  ${window.location.host}` );
  }
  else if(process.env.NEXT_PUBLIC_ENVIRONMENT == "testing")
  {
    notifyToSlackChannel('https://hooks.slack.com/services/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',
                        `message      :-  ${error.toString()} \n stacktrace    :-  ${error.stack} \n  platform     :-  ${window.location.host}` );
  }
  else if(process.env.NEXT_PUBLIC_ENVIRONMENT == "staging")
  {
    notifyToSlackChannel('https://hooks.slack.com/services/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',
                        `message      :-  ${error.toString()} \n stacktrace    :-  ${error.stack} \n  platform     :-  ${window.location.host}` );
  }
  else if(process.env.NEXT_PUBLIC_ENVIRONMENT == "review")
  {
    notifyToSlackChannel('https://hooks.slack.com/services/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',
                        `message      :-  ${error.toString()} \n stacktrace    :-  ${error.stack} \n  platform     :-  ${window.location.host}` );
  }

  return (
     <Error500 />
  )
}